import notifyToSlackChannel from 'react-slack-notification';
import Error500 from './500';

export default function ErrorFallback({error, resetErrorBoundary}) 
{
  if (process.env.NEXT_PUBLIC_ENVIRONMENT == "production")
  {
    notifyToSlackChannel('https://hooks.slack.com/services/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',
                        `message      :-  ${error.toString()} \n stacktrace    :-  ${error.stack} \n  platform     :-  ${window.location.host}` );
  }
  else if(process.env.NEXT_PUBLIC_ENVIRONMENT == "testing")
  {
    notifyToSlackChannel('https://hooks.slack.com/services/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',
                        `message      :-  ${error.toString()} \n stacktrace    :-  ${error.stack} \n  platform     :-  ${window.location.host}` );
  }
  else if(process.env.NEXT_PUBLIC_ENVIRONMENT == "staging")
  {
    notifyToSlackChannel('https://hooks.slack.com/services/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',
                        `message      :-  ${error.toString()} \n stacktrace    :-  ${error.stack} \n  platform     :-  ${window.location.host}` );
  }
  else if(process.env.NEXT_PUBLIC_ENVIRONMENT == "review")
  {
    notifyToSlackChannel('https://hooks.slack.com/services/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',
                        `message      :-  ${error.toString()} \n stacktrace    :-  ${error.stack} \n  platform     :-  ${window.location.host}` );
  }

  return (
     <Error500 />
  )
}